import type { HTMLAttributes } from 'react';
import classNames from 'classnames';
import { PreloadImage } from '$util/PreloadImage';
import { engagingHeroImages } from '$util/image/engagingHeroImages';
import { HeaderImg } from '../styled';

interface VideoHeaderImageProps extends HTMLAttributes<HTMLElement> {
  readonly pathname?: string;
}

const getImage = (pathname: VideoHeaderImageProps['pathname']) => {
  const service = pathname?.split('/')[0] || '';
  return engagingHeroImages[service] || engagingHeroImages.default;
};

export function VideoHeaderImage({ pathname, className }: VideoHeaderImageProps): JSX.Element {
  return (
    <>
      {/* Mobile */}
      <PreloadImage provider="cloudinary" src={getImage(pathname).mobile} displayTo="md" />
      <HeaderImg
        className={classNames('VideoHeaderImage', className)}
        provider="cloudinary"
        src={getImage(pathname).mobile}
        layout="fill"
        objectFit="cover"
        objectPosition="top"
        alt="The easiest way to take care of your car"
        displayTo="md"
      />

      {/* Tablet */}
      <PreloadImage provider="cloudinary" src={getImage(pathname).tablet} displayFrom="md" displayTo="lg" />
      <HeaderImg
        className={classNames('VideoHeaderImage', className)}
        provider="cloudinary"
        src={getImage(pathname).tablet}
        layout="fill"
        objectFit="cover"
        objectPosition="top"
        alt="The easiest way to take care of your car"
        displayFrom="md"
        displayTo="lg"
      />

      {/* Desktop */}
      <PreloadImage provider="cloudinary" src={getImage(pathname).desktop} displayFrom="lg" />
      <HeaderImg
        className={classNames('VideoHeaderImage', className)}
        provider="cloudinary"
        src={getImage(pathname).desktop}
        layout="fill"
        objectFit="cover"
        objectPosition="top"
        alt="The easiest way to take care of your car"
        displayFrom="lg"
      />
    </>
  );
}

VideoHeaderImage.displayName = 'VideoHeaderImage';
